const textNodeToTextPrinter = (node) => {
  return node.value;
};

export { textNodeToTextPrinter };
//# sourceMappingURL=common.text.js.map
